var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2805_1387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8506 38.4525C30.2686 38.4525 38.7141 30.007 38.7141 19.589C38.7141 9.17104 30.2686 0.725586 19.8506 0.725586C9.43264 0.725586 0.987183 9.17104 0.987183 19.589C0.987183 30.007 9.43264 38.4525 19.8506 38.4525Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8505 25.8451C23.3057 25.8451 26.1066 23.0442 26.1066 19.5891C26.1066 16.1339 23.3057 13.333 19.8505 13.333C16.3954 13.333 13.5945 16.1339 13.5945 19.5891C13.5945 23.0442 16.3954 25.8451 19.8505 25.8451Z",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6347 19.5894C32.6347 7.40005 22.9721 6.24661 19.8506 6.96407",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.435 42.9048H27.8123C29.5711 42.9048 30.9969 44.3306 30.9969 46.0894V46.0894C30.9969 47.8483 29.5711 49.2741 27.8123 49.2741H12.435C10.6762 49.2741 9.25037 47.8483 9.25037 46.0894V46.0894C9.25037 44.3306 10.6762 42.9048 12.435 42.9048Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4519 46.0896H32.4983C35.9371 46.0896 39.2351 44.7235 41.6667 42.2919C44.0983 39.8603 45.4643 36.5623 45.4643 33.1235V23.4331",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4644 23.1377C47.4242 23.1377 49.013 21.549 49.013 19.5891C49.013 17.6293 47.4242 16.0405 45.4644 16.0405C43.5045 16.0405 41.9158 17.6293 41.9158 19.5891C41.9158 21.549 43.5045 23.1377 45.4644 23.1377Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2805_1387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon-03.f75c948ed759b8a61600a9928b71bcd3.svg";
export { ForwardRef as ReactComponent };